import Icon from '../../components/Icon.vue'

Icon.register({"regular/trash-alt":{"width":448,"height":512,"paths":[{"d":"M192 188V404C192 410.6 186.6 416 180 416H156C149.4 416 144 410.6 144 404V188C144 181.4 149.4 176 156 176H180C186.6 176 192 181.4 192 188zM292 176H268C261.4 176 256 181.4 256 188V404C256 410.6 261.4 416 268 416H292C298.6 416 304 410.6 304 404V188C304 181.4 298.6 176 292 176zM424 80C437.3 80 448 90.7 448 104V116C448 122.6 442.6 128 436 128H416V464C416 490.5 394.5 512 368 512H80C53.5 512 32 490.5 32 464V128H12C5.4 128 0 122.6 0 116V104C0 90.7 10.7 80 24 80H98.4L132.4 23.3A48-48 0 0 0 173.6 0H274.4A48-48 0 0 0 315.6 23.3L349.6 80H424zM154.4 80H293.6L276.2 50.9A6-6 0 0 1 271 48H177A6-6 0 0 1 171.8 50.9L154.4 80zM368 128H80V458A6-6 0 0 1 86 464H362A6-6 0 0 1 368 458V128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/trash-alt.js
// module id = WcVg
// module chunks = 0